import React, { useState, useEffect } from 'react';

import {
  Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
} from 'reactstrap';
import Icon from 'components/Icons/Icon';
import useHelpKey from '../../../hooks/useHelpKey';
import { useTranslate } from 'react-translate';
import routes from 'routes';

const HelpMenu = React.memo(({ activeRoute }) => {
  const [dropdownOpenHelp, setdropdownOpenHelp] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [visited, setVisited] = useState([]);

  const dropdownToggleHelp = () => {
    setdropdownOpenHelp(!dropdownOpenHelp);
  };
//obtain data Help sending current route of page
  const { title, key, text } = useHelpKey(activeRoute);
  const t = useTranslate('menu');

  useEffect(() => {
    const routeData = routes.find((r) => activeRoute.slice(6).includes(r.path.replace(/(:\S+)\?/, '')));

    //Avoid loading invalid URLs
    if (routeData) {
      const route = routeData.path.replace(/(:\S+)\?/, '');

      //Show dropdown only on commercial demo, and if the user hasn't closed the dropdown
      if (process.env.REACT_APP_ENV_NAME === "develop" && !visited.find(v => v === route) && !clicked) {
        setVisited([...visited, route]);
        setdropdownOpenHelp(true);
      }
    }
    
  }, [activeRoute]);

  return (
    <>
      <Dropdown
        nav
        isOpen={dropdownOpenHelp}
        toggle={dropdownToggleHelp}
        className="help-menu"
        onClick={() => {
          setClicked(true);
        }}
      >
        <DropdownToggle caret nav>
          <Icon file="help.svg" width="21px" title="Practices" />
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem className="help-info">
            <Card testId="help_popup">
              <CardHeader>
                <CardTitle className="d-flex text-primary">
                  <div className="text-title">{t('help')}</div>
                  <div className="icon-times text-dark ml-auto">
                    <i className="fas fa-times"></i>
                  </div>
                </CardTitle>
                <div className="text-subtitle text-capitalize"></div>
              </CardHeader>
              <CardBody>
                <div className="text-help">
                  {/* <h6>{title}</h6> */}
                  {/* <h6 dangerouslySetInnerHTML={{__html: title}} />  */}
                  <div className="help_content" dangerouslySetInnerHTML={{__html: text}} /> 
                  {/* <p>{text}</p> */}
                </div>
              </CardBody>
            </Card>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </>
  );
});

export default HelpMenu;
